import callWebGate from 'api/callWebGate';

export function resetAdToPending(wgToken, adId) {
  const url = `adgenerator/v1/testing/${adId}/pendingReset`;
  const opts = { method: 'POST' };
  return callWebGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return r.text().then(e => { throw Error(e); });
      return r;
    });
}



// WEBPACK FOOTER //
// ./src/api/debug.js